<template>
  <div id="overview">
    <nav-list class="bg-default padded" id="nav-bar"/>
    <div id="overview-details" class="padded">
        <header class="header-with-buttons">
            <h2 class="display-6 overview-header">Welcome</h2>
        </header>
        <p class="muted">You're added to the following projects:
          <span v-for="project in projects">
            {{ project.Name }},
          </span>
        </p>
        <p>You can:</p>
        <ul>
          <li>View the contents</li>
          <li>Add your own project block</li>
          <li>Explore the blocks</li>
        </ul>
    </div>
  </div>
</template>

<script>
  import Loader from '../components/ui/Loader.vue'
  import { userService } from '../services/user.service.js';
  import NavList from '../components/lists/NavList.vue';
  import axios from 'axios'

  export default {
    components: {
      NavList,
      Loader
    },
    data () {
        return {
            projects: [],
            token: JSON.parse(localStorage.getItem('user')).id,
            memberId: JSON.parse(localStorage.getItem('user')).userId
        }
    },
    methods: {
      getProjects(){
        axios.get(process.env.VUE_APP_ROOT_API+'/members/'+this.memberId+'/projects?access_token='+this.token)
        .then(response => {
          this.projects = response.data
          this.loading = false
        })
      }
    },
    mounted(){
      this.getProjects()
    }
  }
</script>

<style lang="scss" scoped>
  #overview{
    display: flex;
    height: 100vh;
    width: 100vw;
  }

  #nav-bar{
    flex: 1;
    height: 100vh;
    overflow: auto;
  }

  #overview-details{
    flex: 4;

    header{
      margin-bottom: 1.5rem;
    }
  }

  @media #{$phone} {
    #overview{
      width: 100vw;
      height: 100vh;
      overflow: hidden;
    }

    #nav-bar{
      flex: 1;
    }

    #overview-details{
      flex: 2;
    }
  }
</style>